import request from '@/utils/request'

// 登录相关
export function getCaptcha() {
    return request({ url: '/auth/captcha', method: 'get' })
}
export function login(data) {
    return request({ url: '/auth/login', method: 'post', data })
}
export function getUserRoutes() {
    return request({ url: '/menu/user-routes', method: 'get' })
}
// 获取菜单列表
export function getMenuList() {
    return request({ url: '/menu/list', method: 'get' })
}

// 保存菜单 (新增或修改)
export function saveMenu(data) {
    // 后端现在统一用 /save 接口
    return request({ url: '/menu/save', method: 'post', data })
}

// 删除菜单
export function deleteMenu(data) {
    return request({ url: '/menu/delete', method: 'post', data })
}

// 用户相关
export function getUserList(params) {
    return request({ url: '/user/list', method: 'get', params })
}
export function addUser(data) {
    return request({ url: '/user/add', method: 'post', data })
}
export function updateUser(data) {
    return request({ url: '/user/update', method: 'put', data })
}
export function deleteUser(data) {
    return request({ url: '/user/delete', method: 'post', data })
}
export function resetUserPassword(data) {
    return request({ url: '/user/reset-password', method: 'post', data })
}
export function getUser(id) {
    return request({ url: `/user/${id}`, method: 'get' })
}
// 角色列表（添加用户时用）
export function getRoleList() {
    return request({ url: '/role/list', method: 'get' })
}
export function deleteRole(data) {
    return request({ url: '/role/delete', method: 'post', data })
}






// === 首页组件管理 (CMS) ===

// 1. 获取组件列表
export function getCmsComponents() {
    return request({ url: '/cms/home/list', method: 'get' })
}

// 2. 保存/更新组件
export function saveCmsComponent(data) {
    return request({ url: '/cms/home/save', method: 'post', data })
}

// 3. 保存排序 (拖拽后调用)
// data 格式示例: [3, 1, 5, 2] (ID数组)
export function sortCmsComponents(data) {
    return request({ url: '/cms/home/sort', method: 'post', data })
}

// 4. 删除组件
export function deleteCmsComponent(data) {
    return request({ url: '/cms/home/delete', method: 'post', data })
}
// === 产品管理 ===
export function getProductList(params) {
    return request({ url: '/product/list', method: 'get', params })
}
export function getProduct(id) {
    return request({ url: `/product/${id}`, method: 'get' })
}
export function saveProduct(data) {
    return request({ url: '/product/save', method: 'post', data })
}
export function deleteProduct(data) {
    return request({ url: '/product/delete', method: 'post', data })
}

// === 字典管理 ===
export function getDictList(params) {
    return request({ url: '/dict/list', method: 'get', params })
}
export function saveDict(data) {
    return request({ url: '/dict/save', method: 'post', data })
}
export function deleteDict(data) {
    return request({ url: '/dict/delete', method: 'post', data })
}

// === 日志管理 ===
export function getLogList(params) {
    return request({ url: '/log/list', method: 'get', params })
}


// === 后台 - 入驻审核 ===
// 分页查询入驻审核列表
export function getAuditList(params) {
    return request({ url: '/admin/audit/page', method: 'get', params })
}
// 审核通过
export function approveAudit(id) {
    return request({ url: `/admin/audit/${id}/approve`, method: 'post' })
}
// 审核拒绝, data: { failReason }
export function rejectAudit(id, data) {
    return request({ url: `/admin/audit/${id}/reject`, method: 'post', data })
}

// === 后台 - 小程序用户 ===
// 分页查询小程序用户
export function getAppUserList(params) {
    return request({ url: '/admin/app-user/page', method: 'get', params })
}
// 后台用户选择器搜索, params: { keyword }
export function getAppUserOptions(params) {
    return request({ url: '/admin/app-user/options', method: 'get', params })
}
// 切换小程序用户启用/禁用状态, data: { status }
export function toggleAppUserStatus(id, data) {
    return request({ url: `/admin/app-user/${id}/status`, method: 'put', data })
}
// 后台为指定用户增加会员天数, data: { days }
export function grantAppUserMembershipDays(id, data) {
    return request({ url: `/admin/app-user/${id}/membership/days`, method: 'put', data })
}
// 删除小程序用户
export function deleteAppUser(id) {
    return request({ url: `/admin/app-user/${id}`, method: 'delete' })
}

// === 后台 - 任务工单 ===
// 分页查询任务工单
export function getAppTaskList(params) {
    return request({ url: '/admin/task/page', method: 'get', params })
}
// 任务工单详情
export function getAppTaskDetail(id) {
    return request({ url: `/admin/task/${id}`, method: 'get' })
}
// 强制关闭任务工单, data: { reason }
export function forceCloseAppTask(id, data) {
    return request({ url: `/admin/task/${id}/force_close`, method: 'post', data })
}
// 设置或取消任务顶置, data: { top }
export function setAppTaskTop(id, data) {
    return request({ url: `/admin/task/${id}/top`, method: 'put', data })
}
// 任务审核通过
export function auditApproveTask(id) {
    return request({ url: `/admin/task/v2/${id}/audit_approve`, method: 'post' })
}
// 后台核审时修改任务文字、金额和服务信息
export function auditEditTask(id, data) {
    return request({ url: `/admin/task/v2/${id}/audit_edit`, method: 'post', data })
}
// 任务审核拒绝, data: { reason }
export function auditRejectTask(id, data) {
    return request({ url: `/admin/task/${id}/audit_reject`, method: 'post', data })
}

// === 后台 - 资金流水 ===
// 分页查询资金流水
export function getFinancialFlowList(params) {
    return request({ url: '/admin/financial-flow/page', method: 'get', params })
}

// === 后台 - 积分管理 ===
// 分页查询积分流水
export function getPointRecordList(params) {
    return request({ url: '/admin/point/page', method: 'get', params })
}
// 后台为用户增加积分, data: { userId, pointsValue, remark }
export function addUserPoints(data) {
    return request({ url: '/admin/point/add', method: 'post', data })
}

// === 后台 - 提现审核 ===
// 分页查询提现申请
export function getWithdrawList(params) {
    return request({ url: '/admin/withdraw/page', method: 'get', params })
}
// 提现申请详情
export function getWithdrawDetail(id) {
    return request({ url: `/admin/withdraw/${id}`, method: 'get' })
}
// 审核通过提现申请
export function approveWithdraw(id) {
    return request({ url: `/admin/withdraw/${id}/approve`, method: 'post' })
}
// 审核拒绝提现申请, data: { rejectReason }
export function rejectWithdraw(id, data) {
    return request({ url: `/admin/withdraw/${id}/reject`, method: 'post', data })
}

// === 后台 - 操作日志高级查询 ===
// 高级日志分页查询
// params: { page, pageSize, operatorId, operatorAccount, operationTypes (Array<String>), startTime, endTime }
// 注意: operationTypes 数组将被 axios 默认序列化为 ?operationTypes=A&operationTypes=B
//       与后端 Spring @RequestParam List<String> 解析方式兼容
export function getLogPage(params) {
    return request({ url: '/log/page', method: 'get', params })
}


// =============================================================================
// 后台 - master-profile-extension 扩展接口
// 共 6 类后台维护 / 审核入口, 全部走 axios 实例 @/utils/request:
//   - 服务技能维护(分类 + 子项 共 8 个端点)
//   - 证书种类维护(5 个)
//   - 车辆种类维护(5 个)
//   - 证书审核(3 个)
//   - 车辆审核(3 个)
// 命名沿用既有 export function 风格, 与 SecurityConfig 权限码对齐
// =============================================================================

// === 服务技能 - 大类(/api/admin/skill-category) ===
export function pageSkillCategory(params) {
    return request({ url: '/admin/skill-category/page', method: 'get', params })
}
export function addSkillCategory(data) {
    // POST /api/admin/skill-category, body 字段: { name, sort, isEnabled }
    return request({ url: '/admin/skill-category', method: 'post', data })
}
export function updateSkillCategory(id, data) {
    return request({ url: `/admin/skill-category/${id}`, method: 'put', data })
}
export function deleteSkillCategory(id) {
    return request({ url: `/admin/skill-category/${id}`, method: 'delete' })
}
export function toggleSkillCategory(id, isEnabled) {
    // PUT /api/admin/skill-category/{id}/toggle?isEnabled=0|1
    return request({ url: `/admin/skill-category/${id}/toggle`, method: 'put', params: { isEnabled } })
}

// === 服务技能 - 子项(/api/admin/skill-item) ===
export function pageSkillItem(params) {
    return request({ url: '/admin/skill-item/page', method: 'get', params })
}
export function addSkillItem(data) {
    // body 字段: { categoryId, name, sort, isEnabled }
    return request({ url: '/admin/skill-item', method: 'post', data })
}
export function updateSkillItem(id, data) {
    return request({ url: `/admin/skill-item/${id}`, method: 'put', data })
}
export function deleteSkillItem(id) {
    return request({ url: `/admin/skill-item/${id}`, method: 'delete' })
}
export function toggleSkillItem(id, isEnabled) {
    return request({ url: `/admin/skill-item/${id}/toggle`, method: 'put', params: { isEnabled } })
}

// === 证书种类(/api/admin/cert-type) ===
export function pageCertType(params) {
    return request({ url: '/admin/cert-type/page', method: 'get', params })
}
export function addCertType(data) {
    return request({ url: '/admin/cert-type', method: 'post', data })
}
export function updateCertType(id, data) {
    return request({ url: `/admin/cert-type/${id}`, method: 'put', data })
}
export function deleteCertType(id) {
    return request({ url: `/admin/cert-type/${id}`, method: 'delete' })
}
export function toggleCertType(id, isEnabled) {
    return request({ url: `/admin/cert-type/${id}/toggle`, method: 'put', params: { isEnabled } })
}

// === 车辆种类(/api/admin/vehicle-type) ===
export function pageVehicleType(params) {
    return request({ url: '/admin/vehicle-type/page', method: 'get', params })
}
export function addVehicleType(data) {
    return request({ url: '/admin/vehicle-type', method: 'post', data })
}
export function updateVehicleType(id, data) {
    return request({ url: `/admin/vehicle-type/${id}`, method: 'put', data })
}
export function deleteVehicleType(id) {
    return request({ url: `/admin/vehicle-type/${id}`, method: 'delete' })
}
export function toggleVehicleType(id, isEnabled) {
    return request({ url: `/admin/vehicle-type/${id}/toggle`, method: 'put', params: { isEnabled } })
}

// === 证书审核(/api/admin/asset-audit/cert) ===
// 三态状态机: 0 待审核 / 1 已通过 / 2 已拒绝, 终态单调
export function pageCertAudit(params) {
    return request({ url: '/admin/asset-audit/cert/page', method: 'get', params })
}
export function approveCertAudit(id) {
    return request({ url: `/admin/asset-audit/cert/${id}/approve`, method: 'post' })
}
export function rejectCertAudit(id, data) {
    // body: { reason }, reason 长度 ∈ [1, 200]
    return request({ url: `/admin/asset-audit/cert/${id}/reject`, method: 'post', data })
}

// === 车辆审核(/api/admin/asset-audit/vehicle) ===
export function pageVehicleAudit(params) {
    return request({ url: '/admin/asset-audit/vehicle/page', method: 'get', params })
}
export function approveVehicleAudit(id) {
    return request({ url: `/admin/asset-audit/vehicle/${id}/approve`, method: 'post' })
}
export function rejectVehicleAudit(id, data) {
    return request({ url: `/admin/asset-audit/vehicle/${id}/reject`, method: 'post', data })
}


// =============================================================================
// 后台 - bidding-task-platform R17~R24 增量接口
//   - 服务类目维护(/api/admin/service-category)         : R18
//   - 服务商品维护(/api/admin/service-product)          : R19
//   - 服务项目维护(/api/admin/service-item)             : R19.5~R19.9
//   - 任务审核未通过修改意见(/api/admin/task/v2/{id}/audit_revision): R21.3
// =============================================================================

// === 服务类目 (/api/admin/service-category) ===
export function uploadCommonFile(file) {
    const data = new FormData()
    data.append('file', file)
    return request({ url: '/common/upload', method: 'post', data })
}
export function getServiceCategoryPage(params) {
    return request({ url: '/admin/service-category/page', method: 'get', params })
}
export function createServiceCategory(data) {
    // body: { name, sort, isEnabled, iconUrl }
    return request({ url: '/admin/service-category', method: 'post', data })
}
export function updateServiceCategory(id, data) {
    return request({ url: `/admin/service-category/${id}`, method: 'put', data })
}
export function deleteServiceCategory(id) {
    return request({ url: `/admin/service-category/${id}`, method: 'delete' })
}

// 公告管理
export function getAnnouncementPage(params) {
    return request({ url: '/admin/announcement/page', method: 'get', params })
}
export function createAnnouncement(data) {
    return request({ url: '/admin/announcement', method: 'post', data })
}
export function updateAnnouncement(id, data) {
    return request({ url: `/admin/announcement/${id}`, method: 'put', data })
}
export function deleteAnnouncement(id) {
    return request({ url: `/admin/announcement/${id}`, method: 'delete' })
}

// === 服务商品 (/api/admin/service-product) ===
export function getServiceProductPage(params) {
    return request({ url: '/admin/service-product/page', method: 'get', params })
}
export function createServiceProduct(data) {
    // body: { categoryId, name, mainImageUrl, status }
    return request({ url: '/admin/service-product', method: 'post', data })
}
export function updateServiceProduct(id, data) {
    return request({ url: `/admin/service-product/${id}`, method: 'put', data })
}
export function deleteServiceProduct(id) {
    return request({ url: `/admin/service-product/${id}`, method: 'delete' })
}

// === 服务项目 (/api/admin/service-item) ===
export function getServiceItemList(params) {
    // params: { productId }
    return request({ url: '/admin/service-item/list', method: 'get', params })
}
export function createServiceItem(data) {
    // body: { productId, name, estimatePrice }
    return request({ url: '/admin/service-item', method: 'post', data })
}
export function updateServiceItem(id, data) {
    return request({ url: `/admin/service-item/${id}`, method: 'put', data })
}
export function deleteServiceItem(id) {
    return request({ url: `/admin/service-item/${id}`, method: 'delete' })
}

// === 任务审核未通过修改意见 (R21.3 / 任务 29.4) ===
// POST /api/admin/task/v2/{id}/audit_revision  body: { revisionRemark }
export function auditRevisionTask(id, data) {
    return request({ url: `/admin/task/v2/${id}/audit_revision`, method: 'post', data })
}
